/** One lit voxel on the board. `y` counts down from the top row. */
export interface Cell {
	x: number
	y: number
	color: number
}

export type Dir = 'up' | 'down' | 'left' | 'right'

export interface GameInput {
	/** Direction currently held (invaders steer with this). */
	held?: Dir
	/** Most recent direction press, consumed once per step (snake turns with this). */
	pressed?: Dir
	fire?: boolean
}

export type GameEvent = 'eat' | 'die' | 'shoot' | 'hit' | 'wave' | 'lose-life' | 'jump' | 'clear'

export interface Game {
	readonly name: 'snake' | 'invaders' | 'dash'
	readonly W: number
	readonly H: number
	/** Milliseconds until the next step. May change as the game speeds up. */
	readonly tickMs: number
	score: number
	over: boolean
	lives?: number
	wave?: number
	/** Advance one tick. In demo mode the game plays itself and ignores input. */
	step(input: GameInput, demo: boolean): GameEvent[]
	cells(): Cell[]
}

export const DELTA: Record<Dir, [number, number]> = { up: [0, -1], down: [0, 1], left: [-1, 0], right: [1, 0] }
export const OPPOSITE: Record<Dir, Dir> = { up: 'down', down: 'up', left: 'right', right: 'left' }
